import { injectIntl, IntlShape } from 'react-intl';
import { useEffect, useMemo } from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { get, isEmpty } from 'lodash';
import { CheckCircle, RadioButtonUnchecked } from '@material-ui/icons';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { translate } from 'containers/services/translate';
import {
  CIVIL_JUDGEMENT,
  JUDGEMENT_EXPERTISE_TYPES,
  MODE_TYPES,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import GeneralCivilProceeding from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/GeneralCivilProceeding';
import { Listings } from 'containers/AppContainer/typings';
import { EXPERTISES } from 'containers/data-structure';
import { EXPERTISES as EXPERTISE_IDS } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/constants';
import { EMPTY_CIVIL_JUDGEMENT } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/data-structure';
import {
  activateCivilJudgementCompensation,
  activateCivilJudgementNonCompensation,
  activateJudgementWithoutCompensation,
  shouldArchivateCurrentExpertise,
  disabledJudgementWithCompensation,
  getCurrentExpertiseForm,
  getMergedAccountingExpertise,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { VictimType } from 'typings/globalTypes';
export interface JudgementForNonCompensationProps {
  intl: IntlShape;
  judgementAddId?: any;
  judgementAddDocExpertises?: any;
  dahirAmounts?: any;
  isAppeal?: boolean;
  victim?: any;
  setExpertiseFieldValue?: Function;
  handleVictimChange?: Function;
  index?: any;
  expertiseType?: string;
  expertises?: any;
  isInputChanged?: any;
  setJudgementOnMeritsRequest?: Function;
  judgementOnMeritsRequest: any;
  listings?: Listings;
  setExpertises?: Function;
  judgement: any;
  setJudgement: Function;
  expertiseJudgementAddDocumentId?: number;
  judgementForNonCompensation?: string;
  modeType: string;
  isRejected?: boolean;
  isContested?: boolean;
  isManager?: boolean;
  dahirAmount?: any;
  handleExpertiseChange?: Function;
  handleOpenContestation?: Function;
  civilJudgementType?: string;
  civj?: any;
  motifListExpertise?: any;
  civjvm?: any;
  handleCivJvmChange?: Function;
  judgementOnMerits?: any;
  sagisVictimInfo?: any;
  civjWithNonCompensation?: any;
  setCivilJudgementUpdateExpertise?: Function;
  setCivilJudgementUpdateAccountingExpertise?: Function;
  civilJudgementUpdateExpertise?: any;
  civilJudgementUpdateAccountingExpertise?: any;
  civjvmRequest?: any;
  setCivjvmRequest?: Function;
  setCivilJudgements?: Function;
  civilJudgements?: any;
  handleVehiculeChange?: Function;
  withAccountingExpertise?: any;
  vehicle?: any;
  isDisabled: boolean;
  allJudgementDocuments?: any;
  sharedResponsability?: any;
}
export const CheckBoxForm = (props: any) => {
  const id =
    props.judgementForNonCompensation === JUDGEMENT_EXPERTISE_TYPES.CIVIL
      ? `${props.expertiseJudgementAddDocumentId}-${props.expertise}-${
          !!props.victim ? props.victim?.id : props.vehicle?.id
        }`
      : props.judgementForNonCompensation ===
        JUDGEMENT_EXPERTISE_TYPES.CIVIL_AND_NON_COMPENSATION
      ? `${props.expertiseJudgementAddDocumentId}-${
          !!props.victim ? props.victim?.id : props.vehicle?.id
        }`
      : `${!!props.victim ? props.victim?.id : props.vehicle?.id}`;
  return (
    <FormControlLabel
      control={
        <Checkbox
          color="primary"
          checked={get(props.judgement[id], props.type, false)}
          checkedIcon={<CheckCircle />}
          icon={<RadioButtonUnchecked />}
          disabled={props.disabled}
          onChange={props.handleItemCheckBox(props.type)}
        />
      }
      label={props.message}
    />
  );
};
export const JudgementForNonCompensation: React.FC<JudgementForNonCompensationProps> = ({
  ...props
}): JSX.Element => {
  const expertise = useMemo(() => {
    return props.expertiseType === EXPERTISES.ACCOUNTING_EXPERTISE
      ? EXPERTISE_IDS.ACCOUNTING
      : props.expertiseType === EXPERTISES.MEDICAL_EXPERTISE
      ? EXPERTISE_IDS.MEDICAL
      : EXPERTISE_IDS.MECHANICAL;
  }, [props.expertiseType]);
  const id = useMemo(() => {
    return props.judgementForNonCompensation === JUDGEMENT_EXPERTISE_TYPES.CIVIL
      ? `${props.expertiseJudgementAddDocumentId}-${expertise}-${
          !!props.victim ? props.victim?.id : props.vehicle?.id
        }`
      : props.judgementForNonCompensation ===
        JUDGEMENT_EXPERTISE_TYPES.CIVIL_AND_NON_COMPENSATION
      ? `${props.expertiseJudgementAddDocumentId}-${
          !!props.victim ? props.victim?.id : props.vehicle?.id
        }`
      : `${!!props.victim ? props.victim?.id : props.vehicle?.id}`;
  }, [props.victim, props.vehicle, props.expertiseJudgementAddDocumentId]);
  const currentDocExpertise =
    get(props, 'judgementAddDocExpertises', []).find(
      (item: any) =>
        item.expertiseJudgementAddDocumentId ===
        props.expertiseJudgementAddDocumentId,
    ) || {};
  const currentVictimExpertise =
    get(currentDocExpertise, 'victims', []).find(
      (victim: VictimType) => victim?.id === get(props, 'victim.id'),
    ) || {};
  const currentVehicleExpertise =
    get(currentDocExpertise, 'vehicules', []).find(
      (vehicle: any) => vehicle?.id === get(props, 'vehicle.id'),
    ) || {};

  useEffect(() => {
    activateCivilJudgementCompensation(
      expertise,
      props.judgement,
      props.civj,
      props.modeType,
      props.judgementForNonCompensation,
      props.expertiseJudgementAddDocumentId,
      props.setJudgement,
      props.victim,
      props.vehicle,
    );
    activateCivilJudgementNonCompensation(
      props.judgement,
      props.civjWithNonCompensation,
      props.modeType,
      props.judgementForNonCompensation,
      props.expertiseJudgementAddDocumentId,
      props.setJudgement,
      props.victim,
      props.vehicle,
      props.listings,
    );
    activateJudgementWithoutCompensation(
      props.judgement,
      props.civjWithNonCompensation,
      props.modeType,
      props.judgementForNonCompensation,
      props.setJudgement,
      props.victim,
      props.vehicle,
      props.listings,
    );
  }, [
    props.modeType,
    props.expertises,
    props.civjvmRequest,
    props.judgementForNonCompensation,
    props.victim,
    props.vehicle,
    props.civjWithNonCompensation,
  ]);

  /* istanbul ignore next */
  const handleItemCheckBox = (type: string) => (
    event: React.ChangeEvent<{ value: string; checked: boolean }>,
  ) => {
    let judgementCheck = { ...props.judgement };
    if (!judgementCheck[id]) {
      judgementCheck[id] = {
        ...EMPTY_CIVIL_JUDGEMENT,
      };
    }

    const currentExpertise = getCurrentExpertiseForm(
      props.expertiseType,
      props.modeType,
      props.expertises,
    );
    const incidentType = !!props.victim ? 'victimId' : 'vehiculeId';
    const incidentId = !!props.victim ? props.victim?.id : props.vehicle?.id;
    const expertiseToUpdate = [...currentExpertise] as any;
    const expertiseToUpdateIndex = expertiseToUpdate
      .map((el: any) => (!!el?.victimId ? el?.victimId : el?.vehiculeId))
      .indexOf(Number(incidentId));
    const civjvmProps = get(props.judgementOnMeritsRequest, 'civjvm', []);
    const civjVehicleProps = get(
      props.judgementOnMeritsRequest,
      'civjVehicle',
      [],
    );
    const accountingCivj = getMergedAccountingExpertise(
      props.civilJudgements,
      props.civj,
    );
    const accountingExpertiseToUpdate =
      get(props.expertises, 'accountingExpertise', []).find(
        (el: any) =>
          get(
            expertiseToUpdate[expertiseToUpdateIndex],
            `${incidentType}`,
            null,
          ) === get(el, `${incidentType}`),
      ) || {};
    switch (type) {
      case CIVIL_JUDGEMENT.VICTIM_CIVIL_JUDGEMENT:
        props.setJudgementOnMeritsRequest &&
          props.setJudgementOnMeritsRequest(
            Object.assign(
              {},
              { ...props.judgementOnMeritsRequest },
              {
                civjvm: {
                  ...civjvmProps,
                  [props.expertiseJudgementAddDocumentId
                    ? `${props.victim?.id}-${props.expertiseJudgementAddDocumentId}`
                    : props.victim?.id]: undefined,
                },
              },
            ),
          );
        judgementCheck[id] = {
          ...EMPTY_CIVIL_JUDGEMENT,
          [CIVIL_JUDGEMENT.VICTIM_CIVIL_JUDGEMENT]: !get(
            judgementCheck[id],
            [CIVIL_JUDGEMENT.VICTIM_CIVIL_JUDGEMENT],
            false,
          ),
        };

        break;
      case CIVIL_JUDGEMENT.VEHICLE_CIVIL_JUDGEMENT:
        props.setJudgementOnMeritsRequest &&
          props.setJudgementOnMeritsRequest(
            Object.assign(
              {},
              { ...props.judgementOnMeritsRequest },
              {
                civjVehicle: {
                  ...civjVehicleProps,
                  [props.expertiseJudgementAddDocumentId
                    ? `${props.vehicle?.id}-${props.expertiseJudgementAddDocumentId}`
                    : props.vehicle?.id]: undefined,
                },
              },
            ),
          );
        judgementCheck[id] = {
          ...EMPTY_CIVIL_JUDGEMENT,
          [CIVIL_JUDGEMENT.VEHICLE_CIVIL_JUDGEMENT]: !get(
            judgementCheck[id],
            [CIVIL_JUDGEMENT.VEHICLE_CIVIL_JUDGEMENT],
            false,
          ),
        };

        break;
      case CIVIL_JUDGEMENT.FORM_REJECTION:
        props.setJudgementOnMeritsRequest &&
          props.setJudgementOnMeritsRequest(
            Object.assign(
              {},
              { ...props.judgementOnMeritsRequest },
              {
                ...(props.victim && {
                  civjvm: {
                    ...civjvmProps,
                    [props.expertiseJudgementAddDocumentId
                      ? `${props.victim?.id}-${props.expertiseJudgementAddDocumentId}`
                      : props.victim?.id]: undefined,
                  },
                }),
                ...(props.vehicle && {
                  civjVehicle: {
                    ...civjVehicleProps,
                    [props.expertiseJudgementAddDocumentId
                      ? `${props.vehicle?.id}-${props.expertiseJudgementAddDocumentId}`
                      : props.vehicle?.id]: undefined,
                  },
                }),
              },
            ),
          );
        expertiseToUpdate[expertiseToUpdateIndex] = {};
        props.setExpertises &&
          props.expertiseType &&
          props.setExpertises(
            Object.assign(
              {},
              { ...props.expertises },
              {
                [props.expertiseType]: [
                  ...expertiseToUpdate.filter((item: any) => !isEmpty(item)),
                ],
                ...(!isEmpty(accountingExpertiseToUpdate) && {
                  [EXPERTISES.ACCOUNTING_EXPERTISE]: [
                    ...get(
                      props.expertises,
                      EXPERTISES.ACCOUNTING_EXPERTISE,
                      [],
                    ).filter(
                      (el: any) =>
                        get(el, `${incidentType}`) !==
                        get(accountingExpertiseToUpdate, `${incidentType}`),
                    ),
                  ],
                }),
              },
            ),
          );

        judgementCheck[id] = {
          ...EMPTY_CIVIL_JUDGEMENT,
          [CIVIL_JUDGEMENT.FORM_REJECTION]: !get(
            judgementCheck[id],
            [CIVIL_JUDGEMENT.FORM_REJECTION],
            false,
          ),
        };
        break;
      case CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION:
        expertiseToUpdate[expertiseToUpdateIndex] = {};
        props.setExpertises &&
          props.expertiseType &&
          props.setExpertises(
            Object.assign(
              {},
              { ...props.expertises },
              {
                [props.expertiseType]: [
                  ...expertiseToUpdate.filter((item: any) => !isEmpty(item)),
                ],
                ...(!isEmpty(accountingExpertiseToUpdate) && {
                  [EXPERTISES.ACCOUNTING_EXPERTISE]: [
                    ...get(
                      props.expertises,
                      EXPERTISES.ACCOUNTING_EXPERTISE,
                      [],
                    ).filter(
                      (el: any) =>
                        get(el, `${incidentType}`) !==
                        get(accountingExpertiseToUpdate, `${incidentType}`),
                    ),
                  ],
                }),
              },
            ),
          );
        props.setJudgementOnMeritsRequest &&
          props.setJudgementOnMeritsRequest(
            Object.assign(
              {},
              { ...props.judgementOnMeritsRequest },
              {
                ...(props.victim && {
                  civjvm: {
                    ...civjvmProps,
                    [props.expertiseJudgementAddDocumentId
                      ? `${props.victim?.id}-${props.expertiseJudgementAddDocumentId}`
                      : props.victim?.id]: undefined,
                  },
                }),
                ...(props.vehicle && {
                  civjVehicle: {
                    ...civjVehicleProps,
                    [props.expertiseJudgementAddDocumentId
                      ? `${props.vehicle?.id}-${props.expertiseJudgementAddDocumentId}`
                      : props.vehicle?.id]: undefined,
                  },
                }),
              },
            ),
          );
        judgementCheck[id] = {
          ...EMPTY_CIVIL_JUDGEMENT,
          [CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION]: !get(
            judgementCheck[id],
            [CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION],
            false,
          ),
        };
        break;
      case CIVIL_JUDGEMENT.CIVIL_JUDGEMENT_VICTIM_RECAP:
        const civjvmRequest = [...props.civjvmRequest];
        const currentCivjvmRequest = civjvmRequest.find(
          item => item?.id === get(props.civjWithNonCompensation, 'id'),
        );
        const index = civjvmRequest.indexOf(currentCivjvmRequest);
        if (index !== -1) {
          civjvmRequest[index] = { ...currentCivjvmRequest, isDeleted: true };
          props.setCivjvmRequest && props.setCivjvmRequest(civjvmRequest);
        }
        shouldArchivateCurrentExpertise(
          props.expertiseType,
          props.civj,
          props.civilJudgementUpdateExpertise,
          props.setCivilJudgementUpdateExpertise,
          props.civilJudgements,
          props.setCivilJudgements,
          false,
        );
        !isEmpty(props.civj) &&
          !isEmpty(accountingCivj) &&
          props.expertiseType !== EXPERTISES.ACCOUNTING_EXPERTISE &&
          get(props.withAccountingExpertise, 'hasAccountingExpertise') &&
          shouldArchivateCurrentExpertise(
            EXPERTISES.ACCOUNTING_EXPERTISE,
            accountingCivj,
            props.civilJudgementUpdateAccountingExpertise,
            props.setCivilJudgementUpdateAccountingExpertise,
            props.civilJudgements,
            props.setCivilJudgements,
            false,
          );
        judgementCheck[id] = {
          ...EMPTY_CIVIL_JUDGEMENT,
          [CIVIL_JUDGEMENT.CIVIL_JUDGEMENT_VICTIM_RECAP]: !get(
            judgementCheck[id],
            [CIVIL_JUDGEMENT.CIVIL_JUDGEMENT_VICTIM_RECAP],
            false,
          ),
        };

        break;
      case CIVIL_JUDGEMENT.CIVIL_JUDGEMENT_VEHICLE_RECAP:
        const civjVehicleRequest = [
          ...get(props.judgementOnMeritsRequest, 'civjVehicle', []),
        ];
        const currentCivjVehicleRequest = civjVehicleRequest.find(
          item => item?.id === get(props.civjWithNonCompensation, 'id'),
        );
        const indexCivjVehicle = civjVehicleRequest.indexOf(
          currentCivjVehicleRequest,
        );
        if (indexCivjVehicle !== -1) {
          civjVehicleRequest[indexCivjVehicle] = {
            ...currentCivjVehicleRequest,
            isDeleted: true,
          };
          props.setJudgementOnMeritsRequest &&
            props.setJudgementOnMeritsRequest({
              ...props.judgementOnMeritsRequest,
              civjVehicle: civjVehicleRequest,
            });
        }
        shouldArchivateCurrentExpertise(
          props.expertiseType,
          props.civj,
          props.civilJudgementUpdateExpertise,
          props.setCivilJudgementUpdateExpertise,
          props.civilJudgements,
          props.setCivilJudgements,
          false,
        );
        judgementCheck[id] = {
          ...EMPTY_CIVIL_JUDGEMENT,
          [CIVIL_JUDGEMENT.CIVIL_JUDGEMENT_VEHICLE_RECAP]: !get(
            judgementCheck[id],
            [CIVIL_JUDGEMENT.CIVIL_JUDGEMENT_VEHICLE_RECAP],
            false,
          ),
        };

        break;
      case CIVIL_JUDGEMENT.FORM_REJECTION_RECAP:
        const civjvmRequestData = !!props.victim
          ? [...props.civjvmRequest]
          : [...get(props.judgementOnMeritsRequest, 'civjVehicle', [])];
        const currentCivjvmRequestData = civjvmRequestData.find(
          item => item?.id === get(props.civjWithNonCompensation, 'id'),
        );
        const civjvmIndex = civjvmRequestData.indexOf(currentCivjvmRequestData);
        if (civjvmIndex !== -1) {
          civjvmRequestData[civjvmIndex] = {
            ...currentCivjvmRequestData,
            reasonId: null,
            otherReason: null,
            isDeleted: false,
          };
          !!props.victim &&
            props.setCivjvmRequest &&
            props.setCivjvmRequest(civjvmRequestData);
          !!props.vehicle &&
            props.setJudgementOnMeritsRequest &&
            props.setJudgementOnMeritsRequest({
              ...props.judgementOnMeritsRequest,
              civjVehicle: civjvmRequestData,
            });
        }
        !isEmpty(props.civj) &&
          shouldArchivateCurrentExpertise(
            props.expertiseType,
            props.civj,
            props.civilJudgementUpdateExpertise,
            props.setCivilJudgementUpdateExpertise,
            props.civilJudgements,
            props.setCivilJudgements,
            true,
          );
        !isEmpty(props.civj) &&
          !isEmpty(accountingCivj) &&
          props.expertiseType !== EXPERTISES.ACCOUNTING_EXPERTISE &&
          get(props.withAccountingExpertise, 'hasAccountingExpertise') &&
          shouldArchivateCurrentExpertise(
            EXPERTISES.ACCOUNTING_EXPERTISE,
            accountingCivj,
            props.civilJudgementUpdateAccountingExpertise,
            props.setCivilJudgementUpdateAccountingExpertise,
            props.civilJudgements,
            props.setCivilJudgements,
            true,
          );
        judgementCheck[id] = {
          ...EMPTY_CIVIL_JUDGEMENT,
          [CIVIL_JUDGEMENT.FORM_REJECTION_RECAP]: !get(
            judgementCheck[id],
            [CIVIL_JUDGEMENT.FORM_REJECTION_RECAP],
            false,
          ),
        };
        break;
      case CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION_RECAP:
        const civjvmRequests = !!props.victim
          ? [...props.civjvmRequest]
          : [...get(props.judgementOnMeritsRequest, 'civjVehicle', [])];
        const currentCivjvmRequests = civjvmRequests.find(
          item => item?.id === get(props.civjWithNonCompensation, 'id'),
        );
        const indexCivjvm = civjvmRequests.indexOf(currentCivjvmRequests);
        if (indexCivjvm !== -1) {
          civjvmRequests[indexCivjvm] = {
            ...currentCivjvmRequests,
            reasonId: null,
            otherReason: null,
            isDeleted: false,
          };
          !!props.victim &&
            props.setCivjvmRequest &&
            props.setCivjvmRequest(civjvmRequests);
          !!props.vehicle &&
            props.setJudgementOnMeritsRequest &&
            props.setJudgementOnMeritsRequest({
              ...props.judgementOnMeritsRequest,
              civjVehicle: civjvmRequests,
            });
        }
        !isEmpty(props.civj) &&
          shouldArchivateCurrentExpertise(
            props.expertiseType,
            props.civj,
            props.civilJudgementUpdateExpertise,
            props.setCivilJudgementUpdateExpertise,
            props.civilJudgements,
            props.setCivilJudgements,
            true,
          );
        !isEmpty(props.civj) &&
          !isEmpty(accountingCivj) &&
          props.expertiseType !== EXPERTISES.ACCOUNTING_EXPERTISE &&
          get(props.withAccountingExpertise, 'hasAccountingExpertise') &&
          shouldArchivateCurrentExpertise(
            EXPERTISES.ACCOUNTING_EXPERTISE,
            accountingCivj,
            props.civilJudgementUpdateAccountingExpertise,
            props.setCivilJudgementUpdateAccountingExpertise,
            props.civilJudgements,
            props.setCivilJudgements,
            true,
          );
        judgementCheck[id] = {
          ...EMPTY_CIVIL_JUDGEMENT,
          [CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION_RECAP]: !get(
            judgementCheck[id],
            [CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION_RECAP],
            false,
          ),
        };
        break;
    }
    props.setJudgement(judgementCheck);
  };
  return (
    <div className="judgement-on-merits-contestation-container">
      <div>
        {props.judgementForNonCompensation !==
          JUDGEMENT_EXPERTISE_TYPES.NON_COMPENSATION &&
          disabledJudgementWithCompensation(
            !!props.victim ? currentVictimExpertise : currentVehicleExpertise,
            props.withAccountingExpertise,
            false,
          ) && (
            <span className="alert">
              {translate(messages.expertReportAlert, props)}
            </span>
          )}
        <div>
          {props.judgementForNonCompensation !==
            JUDGEMENT_EXPERTISE_TYPES.NON_COMPENSATION &&
            !!props.victim && (
              <CheckBoxForm
                type={
                  props.modeType === MODE_TYPES.FORM
                    ? CIVIL_JUDGEMENT.VICTIM_CIVIL_JUDGEMENT
                    : CIVIL_JUDGEMENT.CIVIL_JUDGEMENT_VICTIM_RECAP
                }
                disabled={disabledJudgementWithCompensation(
                  currentVictimExpertise,
                  props.withAccountingExpertise,
                  props.isDisabled,
                )}
                handleItemCheckBox={handleItemCheckBox}
                message={translate(messages.civilJudgementRadioLabel, props)}
                expertise={expertise}
                {...props}
              />
            )}
          {props.judgementForNonCompensation !==
            JUDGEMENT_EXPERTISE_TYPES.NON_COMPENSATION &&
            !!props.vehicle && (
              <CheckBoxForm
                type={
                  props.modeType === MODE_TYPES.FORM
                    ? CIVIL_JUDGEMENT.VEHICLE_CIVIL_JUDGEMENT
                    : CIVIL_JUDGEMENT.CIVIL_JUDGEMENT_VEHICLE_RECAP
                }
                disabled={disabledJudgementWithCompensation(
                  currentVehicleExpertise,
                  props.withAccountingExpertise,
                  props.isDisabled,
                )}
                handleItemCheckBox={handleItemCheckBox}
                message={translate(messages.civilJudgementRadioLabel, props)}
                expertise={expertise}
                {...props}
              />
            )}
          <CheckBoxForm
            type={
              props.modeType === MODE_TYPES.FORM
                ? CIVIL_JUDGEMENT.FORM_REJECTION
                : CIVIL_JUDGEMENT.FORM_REJECTION_RECAP
            }
            handleItemCheckBox={handleItemCheckBox}
            disabled={props.isDisabled}
            message={translate(messages.formRejectionRadioLabel, props)}
            expertise={expertise}
            {...props}
          />
          <CheckBoxForm
            type={
              props.modeType === MODE_TYPES.FORM
                ? CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION
                : CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION_RECAP
            }
            disabled={props.isDisabled}
            handleItemCheckBox={handleItemCheckBox}
            message={translate(messages.substantiveRejectionRadioLabel, props)}
            expertise={expertise}
            {...props}
          />
        </div>
      </div>
      <div>
        {!!props.judgement[id] &&
          props.judgement[id][CIVIL_JUDGEMENT.VICTIM_CIVIL_JUDGEMENT] && (
            <GeneralCivilProceeding
              key={id}
              {...props}
              mode={CIVIL_JUDGEMENT.VICTIM_CIVIL_JUDGEMENT}
            />
          )}
        {!!props.judgement[id] &&
          props.judgement[id][CIVIL_JUDGEMENT.VEHICLE_CIVIL_JUDGEMENT] && (
            <GeneralCivilProceeding
              key={id}
              {...props}
              mode={CIVIL_JUDGEMENT.VEHICLE_CIVIL_JUDGEMENT}
            />
          )}
        {!!props.judgement[id] &&
          props.judgement[id][CIVIL_JUDGEMENT.CIVIL_JUDGEMENT_VICTIM_RECAP] &&
          props.judgementForNonCompensation !==
            JUDGEMENT_EXPERTISE_TYPES.NON_COMPENSATION &&
          props.modeType === MODE_TYPES.RECAP && (
            <GeneralCivilProceeding
              key={id}
              {...props}
              mode={CIVIL_JUDGEMENT.CIVIL_JUDGEMENT_VICTIM_RECAP}
            />
          )}
        {!!props.judgement[id] &&
          props.judgement[id][CIVIL_JUDGEMENT.CIVIL_JUDGEMENT_VEHICLE_RECAP] &&
          props.judgementForNonCompensation !==
            JUDGEMENT_EXPERTISE_TYPES.NON_COMPENSATION &&
          props.modeType === MODE_TYPES.RECAP && (
            <GeneralCivilProceeding
              key={id}
              {...props}
              mode={CIVIL_JUDGEMENT.CIVIL_JUDGEMENT_VEHICLE_RECAP}
            />
          )}
        {!!props.judgement[id] &&
          props.judgement[id][CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION_RECAP] &&
          props.modeType === MODE_TYPES.RECAP && (
            <GeneralCivilProceeding
              key={id}
              {...props}
              mode={CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION_RECAP}
            />
          )}
        {!!props.judgement[id] &&
          props.judgement[id][CIVIL_JUDGEMENT.FORM_REJECTION_RECAP] &&
          props.modeType === MODE_TYPES.RECAP && (
            <GeneralCivilProceeding
              key={id}
              {...props}
              mode={CIVIL_JUDGEMENT.FORM_REJECTION_RECAP}
            />
          )}
        {!!props.judgement[id] &&
          props.judgement[id][CIVIL_JUDGEMENT.FORM_REJECTION] && (
            <GeneralCivilProceeding
              key={id}
              {...props}
              mode={CIVIL_JUDGEMENT.FORM_REJECTION}
            />
          )}
        {!!props.judgement[id] &&
          props.judgement[id][CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION] && (
            <GeneralCivilProceeding
              key={id}
              {...props}
              mode={CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION}
            />
          )}
      </div>
    </div>
  );
};
export default injectIntl(JudgementForNonCompensation);
